import {
    URLAPI,
    UPDATE_ACTIVITY_PATH,
    UPDATE_ACTIVITY_CREATE_PATH,
    UPDATE_ACTIVITY_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_update_activity: {
        data: [],
        status: 0,
        message: {},
    },
    _create_update_activity: {
        data: {},
        status: 0,
        message: {},
    },
    _update_update_activity: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_UPDATE_ACTIVITY = "GET_ALL_UPDATE_ACTIVITY";
export const CREATE_UPDATE_ACTIVITY = "CREATE_UPDATE_ACTIVITY";
export const UPDATE_UPDATE_ACTIVITY = "UPDATE_UPDATE_ACTIVITY";

export const update_activity_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_UPDATE_ACTIVITY:
            return {
                ...state,
                _get_all_update_activity: action.payload,
            };
        case CREATE_UPDATE_ACTIVITY:
            return {
                ...state,
                _create_update_activity: action.payload,
            };
        case UPDATE_UPDATE_ACTIVITY:
            return {
                ...state,
                _update_update_activity: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllUpdateActivity = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${UPDATE_ACTIVITY_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_UPDATE_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_UPDATE_ACTIVITY,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_UPDATE_ACTIVITY,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createUpdateActivity = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${UPDATE_ACTIVITY_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_UPDATE_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_UPDATE_ACTIVITY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_UPDATE_ACTIVITY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateUpdateActivity = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${UPDATE_ACTIVITY_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_UPDATE_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_UPDATE_ACTIVITY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_UPDATE_ACTIVITY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_update_activity = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
